module.exports = __webpack_public_path__ + "static/media/failed-to-load.94ee149b.svg";